/* RESPONSIBLE TEAM: team-ai-insights */
export function convertMarkdownToHtml(
  markdown: string,
  includeLinks = true,
  includeExample = true,
) {
  let text = markdown;
  if (!text) {
    return '';
  }

  // Remove "customers said" section and its bullet points if includeExample is false
  if (!includeExample) {
    text = text.replace(/\*\*Key verbatims:\*\*\s*\n(?:- [^\n]*\n?)*/gi, '');
  }

  // Replace markdown-style links [text](id) with clickable elements or plain text
  text = text.replace(/\[([^\]]+)\]\((\d+)\)/g, (_match, linkText, conversationId) => {
    if (includeLinks) {
      return `<a href="#" class="text-blue-600 hover:text-blue-800 underline cursor-pointer" data-conversation-id="${conversationId}">${linkText}</a>`;
    } else {
      return linkText;
    }
  });

  // Convert markdown headers (####) to HTML h4 tags
  text = text.replace(/^#### (.+)$/gm, '<h4 class="text-lg font-semibold mt-4 mb-2">$1</h4>');

  // Convert markdown bold (**text**) to HTML strong tags
  text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

  // Convert markdown italics (*text*) to HTML em tags
  text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>');

  // Convert markdown bullet points to HTML list items
  text = text.replace(/^- (.+)$/gm, '<li class="ml-4">$1</li>');

  // Wrap consecutive list items in ul tags
  text = text.replace(/(<li[^>]*>.*<\/li>)(\s*<li[^>]*>.*<\/li>)*/gs, (match) => {
    return `<ul class="list-disc pl-4 mb-2">${match}</ul>`;
  });

  // Remove newlines within ul elements, then convert remaining newlines to <br> tags
  text = text.replace(/<ul[^>]*>(.*?)<\/ul>/gs, (match, content) => {
    // Remove newlines within ul content
    let cleanedContent = content.replace(/\n/g, '');
    return match.replace(content, cleanedContent);
  });

  // Convert remaining markdown newlines to HTML br tags
  text = text.replace(/\n/g, '<br>');

  return text;
}
